import { render, staticRenderFns } from "./AffiliatesBanners.vue?vue&type=template&id=1f4d3f12&"
import script from "./AffiliatesBanners.vue?vue&type=script&lang=js&"
export * from "./AffiliatesBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4d3f12')) {
      api.createRecord('1f4d3f12', component.options)
    } else {
      api.reload('1f4d3f12', component.options)
    }
    module.hot.accept("./AffiliatesBanners.vue?vue&type=template&id=1f4d3f12&", function () {
      api.rerender('1f4d3f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesBanners.vue"
export default component.exports